import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { ActionIconDef, GridConfig } from '@inavista/components/grid';
import { environment } from 'projects/service/src/environments/environment';

// Claims page → Add Claim: "Service Orders list for Claims" on @inavista/components. Same columns, labels, link and
// action as the Syncfusion grid it replaces. Rows come from RIMS API: the caller's completed or costed orders with no
// claim yet (the employee from the login token), the ISC list for ISC roles and the other list for everyone else, as
// the old ServiceOrder/GetServiceOrdersForClaims and ISCServiceOrder/GetISCServiceOrdersForClaims.

export const CREATE_CLAIM_ACTION = 'create-claim';

const ARROW_ICON = '<line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />';

export const CLAIM_SERVICE_ORDERS_ACTION_ICONS: ActionIconDef[] = [
  { key: CREATE_CLAIM_ACTION, label: 'Create a claim', colorFn: () => '#000000de', icon: ARROW_ICON },
];

const SHOWN = ['serviceOrderId', 'completedDate', 'totalAmount'];

export function buildClaimServiceOrdersGridConfig(isIsc: boolean): GridConfig {
  return {
    apiBaseUrl: `${environment.apiUrl}grid/${isIsc ? 'isc-claim-service-orders' : 'claim-service-orders'}`,
    keyColumn: 'serviceOrderId',
    title: 'Service Orders',
    rowHeight: 26,
    loadingIndicator: 'banner',
    defaultColumnOrder: SHOWN,
    // The procedures' other columns, never shown by the old grid; in the column chooser.
    startHiddenColumns: ['serviceOrderIdLN', 'nteAmount'],
    columnLabels: {
      serviceOrderId: 'Service Order', completedDate: 'Completion Date', totalAmount: 'Total Amount',
      serviceOrderIdLN: 'LN Service Order No.', nteAmount: 'NTE Amount',
    },
    // RIMS grid look: headers left; dates left; IDs centred; amounts right.
    columnAlign: {
      serviceOrderId: { header: { horizontal: 'left' }, horizontal: 'center' },
      serviceOrderIdLN: { header: { horizontal: 'left' }, horizontal: 'center' },
      completedDate: { header: { horizontal: 'left' } },
      totalAmount: { header: { horizontal: 'left' }, horizontal: 'right' },
      nteAmount: { header: { horizontal: 'left' }, horizontal: 'right' },
    },
    columnWidths: { serviceOrderId: 140, completedDate: 140, totalAmount: 140, serviceOrderIdLN: 150, nteAmount: 120 },
    columnDateFormats: { completedDate: 'd MMM, yyyy' },
    columnTypes: { completedDate: 'date' },
    columnNumberFormats: {
      totalAmount: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
      nteAmount: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    },
    // Service Order opens the order, as before.
    hyperlinkColumns: ['serviceOrderId'],
    enableContextMenuFilter: true,
    // Excel for everyone, as before (this grid had no export rule).
    enableExport: true,
    // The old Refresh button.
    enableRefresh: true,
    enableFitColumns: true,
    enableSavedViews: true,
    enableResetLayout: true,
    wrapHeaders: true,
    emptyStateMessage: 'No completed service order without a claim.',
    persistenceKey: 'rims.service.claim-service-orders',
    firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
    persistenceVersion: 1,
  };
}
